export const EndedPaymentPlanView = () => {
  return (
    <div className="flex items-center justify-center py-3xl">
      <div className="flex flex-col items-center gap-l text-center">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="24" cy="24" r="20" stroke="#00B278" strokeWidth="2.5" />
          <path
            d="M15 24L21 30L33 18"
            stroke="#00B278"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h3 className="m-0 text-l font-bold text-structure-20">
          This plan has been fully funded and is complete.
        </h3>
      </div>
    </div>
  );
};
